import { Component, Output, Input, EventEmitter, ViewChildren, ViewChild, QueryList } from '@angular/core';
import { ApiService } from '../../shared/api.service';
import { ImagesService } from '../../shared/images.service';
import {Utils} from '../../utils';
import { CropperComponent } from './cropper.component';

@Component({
    selector: 'image-details-component',
    templateUrl: 'image-details.component.html'
})
export class ImageDetailsComponent {
    canvas;
    canvasContext;
    captionCharacterCount = 45;
    brightness = 0;
    contrast = 0;
    options = false;
    saving = false;
    sizes = {
        mobile: {
            value: 'mobile',
            label: 'Mobile',
            fixed: false,
            width: 480,
            height: 720
        },
        medium: {
            value: 'medium',
            label: 'Mobile',
            fixed: false,
            width: 480,
            height: 0
        },
        desktop: {
            value: 'desktop',
            label: 'Desktop',
            fixed: false,
            width: 800,
            height: 533
        },
        quiz: {
            value: 'quiz',
            label: 'Quiz',
            fixed: true,
            width: 756,
            height: 331
        },
        ad: {
            value: 'ad',
            label: 'Ad',
            fixed: true,
            width: 1200,
            height: 628
        },
        feed_applenews: {
            value: 'feed_applenews',
            label: 'Feed - Apple News',
            fixed: true,
            width: 800,
            height: 800
        },
    };
    imageDetailsTitle = this.utils.rand();
    imageDetailsAlt = this.utils.rand();
    private _addToSlide = false;
    private _canEdit = false;
    private _dialog = false;
    private _image = {
        alt: '',
        caption: '',
        id: 0,
        title: '',
        url: '',
        sizes: <any>[],
        width: 0,
        height: 0,
        techniques: <any>{},
    };
    private _post = 0;
    private _quiz = false;
    private _showDesktop = false;
    private _adsTab = false;
    private _mustAddDetails = false;
    private _techniques = [];

    @Input('addToSlide')
    set addToSlide(addToSlide) {
        this._addToSlide = addToSlide;
    }
    get addToSlide() {
        return this._addToSlide;
    }
    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('dialog')
    set dialog(dialog) {
        this._dialog = dialog;
    }
    get dialog() {
        return this._dialog;
    }
    @Input('image') 
    set image(image) {
        this._image = image;
    }
    get image() {
        return this._image;
    }
    @Input('post') 
    set post(post) {
        this._post = post;
    }
    get post() {
        return this._post;
    }
    @Input('quiz') 
    set quiz(quiz) {
        this._quiz = quiz;
    }
    get quiz() {
        return this._quiz;
    }
    @Input('showDesktop') 
    set showDesktop(showDesktop) {
        this._showDesktop = showDesktop;
    }
    get showDesktop() {
        return this._showDesktop;
    }
    @Input('adsTab') 
    set adsTab(adsTab) {
        this._adsTab = adsTab;
    }
    get adsTab() {
        return this._adsTab;
    }
    @Input('mustAddDetails') 
    set mustAddDetails(mustAddDetails) {
        this._mustAddDetails = mustAddDetails;
    }
    get mustAddDetails() {
        return this._mustAddDetails;
    }
    get techniques() {
        return this._techniques;
    }

    @Output() imageChange = new EventEmitter();
    @Output() done = new EventEmitter();

    @ViewChildren('cropper') croppers: QueryList<CropperComponent>;
    @ViewChild('desktopCropper') desktopCropper: CropperComponent;
    
    constructor(
        private api: ApiService, 
        public imagesService: ImagesService,
        private utils: Utils
    ) {}
    ngAfterViewInit() {
        const techniques = JSON.parse(JSON.stringify( this.api.getProp('techniques') ));
        for (const key in techniques) {
            this.techniques.push({ label: key, options: techniques[key] });
            this.image.techniques[key] = this.image.techniques[key] || '';
        }
        if( this.image.title !== '' && this.image.alt == '' ) {
            this.image.alt = this.image.title;
        }
        const crop = this.image['crop'] || {};
        if( crop.b ) {
            this.brightness = crop.b / 100;
        }
        if( crop.c ) {
            this.contrast = crop.c / 100;
        }
        if (this.adsTab && (!this.image.sizes.ad || this.image.sizes.ad.width !== 1200 || this.image.sizes.ad.height !== 628)) {
            this.imagesService.resetAdSize(this.image);
        }
        if (!this.image.sizes.feed_applenews) {
            this.imagesService.resetAppleNewsSize(this.image);
        }
        if (this.techniques && (!this.image.techniques || Object.keys(this.image.techniques).length == 0)) {
            this.image.techniques = {};
            this.techniques.forEach(technique => {
                this.image.techniques[technique.label] = '';
            });
        }
    }
    cleanText(text) {
        return text.replace(/(<([^>]+)>)/ig,'');
    }
    getCharacterCount() {
        return this.cleanText(this.image.caption).length;
    }
    titleChange() {
        this.image.title = this.cleanText(this.image.title);
        this.save();
    }
    altChange() {
        this.image.alt = this.cleanText(this.image.alt);
        this.save();
    }
    save() {
        if( !this.image.id ) {
            return;
        }
        const data = {
            action: 'update',
            image: this.image
        }
        this.api.doAction('post', 'image', data).subscribe();
        this.imagesService.imagesChange.emit(this.imagesService.images);
    }
    updateTechnique(label: string, value: string) {
        this.image.techniques[label] = value;
        this.save();
    }
    updateAllCroppers() {
        const croppers = this.croppers;
        croppers.forEach((cropper, i) => {
            cropper.filterImage({
                brightness: this.brightness,
                contrast: this.contrast
            });            
        });
        let sizes = Object.keys(this.image.sizes);
        const newCrop = {
            b: Math.round(this.brightness * 100),
            c: Math.round(this.contrast * 100)
        }
        const crop = this.image['crop'];
        if( !crop ) {
            this.image['crop'] = newCrop;
        } else if (!this.adsTab) {
            this.image['crop'] = Object.assign(crop, newCrop);
        }
        const copyCrop = JSON.parse(JSON.stringify(newCrop));
        if (this.adsTab) {
            this.updateImageCropDetails('ad', copyCrop);
        } else {
            for(var i = 0; i < sizes.length; i++) {
                const size = sizes[i];
                if (size != 'ad') {
                    this.updateImageCropDetails(size, copyCrop);
                }
            }
        }
    }
    updateImageCropDetails(size: string, newCrop: { b: number; c: number; }) {
        let image = this.image.sizes[size];
        if (image.crop) {
            this.image.sizes[size].crop = Object.assign(image.crop, newCrop);
            this.image.sizes[size].crop.width = image.width;
            this.image.sizes[size].crop.height = image.height;
        } else {
            this.image.sizes[size].crop = Object.assign(newCrop, {
                width: image.width,
                height: image.height
            });
        }
        this.image.sizes[size].urlWithParams = this.image.url + this.image['buildHttpParams'](image.crop);
        this.imagesService.refreshImage(this.image.id, image.urlWithParams, size);
    }
    resetOptions() {
        this.brightness = 0;
        this.contrast = 0;
        this.updateAllCroppers();
    }
    optionChange(e, filter) {
        this[filter] = e.value;
        this.updateAllCroppers();
    }
    userCanView(size) {
        const user = this.api.getProp('user');
        if( user.role == 'writer' && (size != 'medium' && size !== 'mobile' && size != 'quiz' && size != 'thumbnail') ) {
            return false;
        }
        return true;
    }
    allowLandscapeChange(e) {
        if( !e.checked ) {
            this.imagesService.resetMobileSize(this.image, false);
            return;
        }
        delete this.image.sizes['mobile'];
        if( this.image.sizes['medium'].width != 480 ) {
            const width = 480;
            const height = this.image.height * (width / this.image.width);
            this.image.sizes['medium'].crop = {
                width: width,
                height: Math.round(height)
            };
            if( this.image['crop'] ) {
                this.image.sizes['medium'].crop.b = this.image['crop'].b;
                this.image.sizes['medium'].crop.c = this.image['crop'].c;
            }
            this.image.sizes['medium'].urlWithParams = this.image.url + this.image['buildHttpParams'](this.image.sizes['medium'].crop);
        } else if ( this.image['crop'] ) {
            this.image.sizes['medium'].crop = {
                b: this.image['crop'].b,
                c: this.image['crop'].c,
                width: this.image.sizes['medium'].width,
                height: this.image.sizes['medium'].height
            };
            this.image.sizes['medium'].urlWithParams = this.image.url + this.image['buildHttpParams'](this.image.sizes['medium'].crop);
        } 
        this.imagesService.imagesChange.emit(this.imagesService.images);
    }
    allowPortraitChange(e) {
        if( !e.checked ) {
            this.imagesService.resetDesktopSize(this.image, false);
            this.imagesService.imagesChange.emit(this.imagesService.images);
            if( this.desktopCropper ) {
                this.desktopCropper.canvas.dispose();
                this.desktopCropper.initCanvas();
            }
            return;
        }
        this.image['allowPortrait'] = true;
        this.image['allow600'] = false;
        const width = 800;
        const height = this.image.height * (width / this.image.width);
        const newCrop = {
            width: width,
            height: Math.round(height)
        }
        const crop = this.image['crop'];
        if( crop && (crop.b || crop.c) ) {
            newCrop['b'] = crop.b;
            newCrop['c'] = crop.c;
        }
        if( !this.image.sizes['desktop'] ) {
            this.image.sizes['desktop'] = {
                width: 800,
                height: 533
            };
        }
        this.image.sizes['desktop'].crop = newCrop;
        this.image.sizes['desktop'].urlWithParams = this.image.url + this.image['buildHttpParams'](this.image.sizes['desktop'].crop);
        this.imagesService.imagesChange.emit(this.imagesService.images);
        if( this.desktopCropper ) {
            this.desktopCropper.canvas.dispose();
            this.desktopCropper.initCanvas();
        }
    }
    hasSmallDesktop() {
        return this.image.sizes['full'].width < 800;
    }
    allow600Change(e) {
        if( !e.checked ) {
            this.imagesService.resetDesktopSize(this.image, false);
            this.imagesService.imagesChange.emit(this.imagesService.images);
            return;
        }
        delete this.image.sizes['desktop'];
        this.image['allowPortrait'] = false;
        this.image['allow600'] = true;
        let image = this.image.sizes['full'];
        const width = image.width >= 600 ? image.width : 600;
        const height = this.image.height * (width / image.width);
        const newCrop = {
            width: width,
            height: Math.round(height)
        };
        if( image.crop && (image.crop.b || image.crop.c) ) {
            newCrop['b'] = image.crop.b;
            newCrop['c'] = image.crop.c;
        }
        image.crop = newCrop;
        this.image['crop'] = newCrop;
        image.urlWithParams = this.image.url + this.image['buildHttpParams'](image.crop);
        this.image['urlWithParams'] = image.urlWithParams;
        this.imagesService.imagesChange.emit(this.imagesService.images);
    }
    exit(action) {
        this.done.emit({
            action: action,
            image: this.image
        });
    }

}